// import React, { useEffect, useState } from "react";
// import { Table, Badge, OverlayTrigger, Tooltip, Row, Col, Card, Form, Button } from "react-bootstrap";
// import { motion } from "framer-motion";
// import { useForm, Controller, useFieldArray } from 'react-hook-form';
// import Select from "react-select";
// import axios from "axios";
// import './AddPublisher.css'
// import { label } from "framer-motion/client";
// import { useNavigate } from "react-router-dom";
// import API from "../../../services/axiosInstance";

import PublisherForm from '../PublisherForm'

const AddPublisher = () => {
    // const navigate = useNavigate();
    // const [rolesList, SetRolesList] = useState([]);
    // const { control, handleSubmit, register, watch, reset, formState: { errors } } = useForm({
    //     defaultValues: {},
    // });
    // const password = watch("password");
    // const roleList = async () => {
    //     try {
    //         const roleListRes = await API.get('/tech/users/user/accounts/list');
    //         SetRolesList(roleListRes?.data?.data);
    //     } catch (error) { console.error('API error', error); }
    // }
    // const onSubmit = async (data) => {
    //     const payload = {
    //         name: data.name,
    //         userId: data.userId,
    //         email: data.userId,
    //         password: data.password,
    //         roleSetId: Number(data.roleSetId),
    //         accountType: 1,
    //         email: data.email,
    //         phone: data.phone,
    //         contactDetail: data.contactDetail,
    //         companyName: data.companyName,
    //         brand: data.brand,
    //         city: data.city,
    //         address: data.address,
    //         country: data.country,
    //         languageType: 1,
    //     }
    //     try {
    //         const response = await API.post("/publisher/add/account",
    //             payload,
    //         );
    //         if (response?.data?.status === "failed") {
    //             alert("Form created successfully");
    //             reset();
    //         } else {
    //             alert(response?.data?.message);
    //         }
    //     } catch (error) {
    //         console.error("API Error:", error);
    //         alert(error?.response?.data?.message || "Something went wrong!");
    //     }
    // };
    // useEffect(() => {
    //     roleList();
    // }, []);
    // return (
    //     <Card className="p-3 instreamRows">
    //         <h6 className="title">Account Information</h6>
    //         <span className="text-danger mb-5" style={{ fontSize: "12px" }}>All fields marked with * are mandatory</span>
    //         <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
    //             <Card className="p-3">
    //                 <h6 className="subTitle">Account Information</h6>
    //                 {/* Account Name */}
    //                 <Row>
    //                     <Col md={3}>
    //                         <label>Account Name <span className="text-danger">*</span></label>
    //                     </Col>
    //                     <Col md={5}>
    //                         <Form.Control type="text" className="form-control" name="name" placeholder="Enter here..." {...register("name", { required: "Account Name is required" })} />
    //                         {errors.name && <p className="text-danger">{errors.name.message}</p>}
    //                     </Col>
    //                 </Row>
    //                 {/* User ID */}
    //                 <Row>
    //                     <Col md={3}>
    //                         <label>User ID <span className="text-danger">*</span></label>
    //                     </Col>
    //                     <Col md={5}>
    //                         <Form.Control type="text" className="form-control" name="userId" placeholder="Enter here..." autoComplete="off" {...register("userId", { required: "User ID is required" })} />
    //                         {errors.userId && <p className="text-danger">{errors.userId.message}</p>}
    //                     </Col>
    //                 </Row>
    //                 {/* Password */}
    //                 <Row>
    //                     <Col md={3}>
    //                         <label>Password <span className="text-danger">*</span></label>
    //                     </Col>
    //                     <Col md={5}>
    //                         <Form.Control type="password" className="form-control" name="password" placeholder="Enter here..." autoComplete="off" {...register("password", {
    //                             required: "Password is required",
    //                             minLength: {
    //                                 value: 6,
    //                                 message: "Password must be at least 6 characters"
    //                             }
    //                         })} />
    //                         {errors.password && <p className="text-danger">{errors.password.message}</p>}
    //                     </Col>
    //                 </Row>
    //                 {/* Confirm Password */}
    //                 <Row>
    //                     <Col md={3}>
    //                         <label>Confirm Password <span className="text-danger">*</span></label>
    //                     </Col>
    //                     <Col md={5}>
    //                         <Form.Control type="password" className="form-control" name="verify_password" placeholder="Enter here..." autoComplete="off" {...register("confirmPassword", {
    //                             required: "Confirm Password is required",
    //                             validate: (value) =>
    //                                 value === password || "Passwords do not match"
    //                         })} />
    //                         {errors.confirmPassword && <p className="text-danger">{errors.confirmPassword.message}</p>}
    //                     </Col>
    //                 </Row>
    //             </Card>

    //             <Card className="p-3 mt-5">
    //                 <h6 className="subTitle">Roles</h6>
    //                 {/* Role */}
    //                 <Row>
    //                     <Col md={3}>
    //                         <label>Role <span className="text-danger">*</span></label>
    //                     </Col>
    //                     <Col md={5}>
    //                         {/* <Controller className ="fieldFont" name = "roleSetId" control={control} rules={{ required: "Please select at least one" }} render= {({ field }) =>(
    //                         <Select className ="fieldFont basic-multi-select" classNamePrefix="select" {...field} isMulti={false} options={roles}  isSearchable ={false} placeholder="Please Select"/>
    //                         )} /> */}
    //                         <Form.Select name="roleList" {...register("roleList", { required: "Role is required" })}>
    //                             <option value="">Please Select</option>
    //                             {
    //                                 rolesList?.map((roles, index) => (
    //                                     <option key={roles?.index} value={roles.id}>
    //                                         {roles.name}
    //                                     </option>
    //                                 ))
    //                             }
    //                         </Form.Select>
    //                         {errors.roleList && <p className="text-danger">{errors.roleList.message}</p>}
    //                     </Col>
    //                 </Row>
    //                 {/* Permission */}
    //                 {/* <Row>
    //                     <Col md={3}>
    //                         <label>Permission <span className="text-danger">*</span></label>
    //                     </Col>
    //                     <Col md={5}>
    //                         <Controller className ="fieldFont" name = "permissions" control={control} rules={{ required: "Please select at least one" }} render= {({ field }) =>(
    //                         <Select className ="fieldFont basic-multi-select" classNamePrefix="select" {...field} isMulti options={permission}  isSearchable ={false} placeholder="Please Select"/>
    //                         )} />
    //                         {errors.roles && <p className="text-danger">{errors.roles.message}</p>}
    //                     </Col>
    //                 </Row> */}
    //             </Card>
    //             <Card className="p-3 mt-5">
    //                 <h6 className="subTitle">Contact Information</h6>
    //                 {/* Email ID */}
    //                 <Row>
    //                     <Col md={3}>
    //                         <label>Email ID <span className="text-danger">*</span></label>
    //                     </Col>
    //                     <Col md={5}>
    //                         <Form.Control type="email" className="form-control" name="email" placeholder="Enter here..." {...register("email", {
    //                             required: "Email is required"
    //                         })} />
    //                         {errors.email && <p className="text-danger">{errors.email.message}</p>}

    //                     </Col>
    //                 </Row>
    //                 {/* Contact Number */}
    //                 <Row>
    //                     <Col md={3}>
    //                         <label>Contact Number</label>
    //                     </Col>
    //                     <Col md={5}>
    //                         <Form.Control type="number" className="form-control" name="phone" placeholder="Enter here..." {...register("phone",
    //                             // {required: "phone is required"}
    //                         )} />
    //                         {/* {errors.phone && <p className="text-danger">{errors.phone.message}</p>} */}

    //                     </Col>
    //                 </Row>
    //                 {/* Contact Person Detail */}
    //                 <Row>
    //                     <Col md={3}>
    //                         <label>Contact Person Detail</label>
    //                     </Col>
    //                     <Col md={5}>
    //                         <Form.Control type="text" className="form-control" name="contactDetail" placeholder="Enter here..." {...register("contactDetail",
    //                             // {required: "contact Person is required"}
    //                         )} />
    //                         {/* {errors.contactDetail && <p className="text-danger">{errors.contactDetail.message}</p>} */}

    //                     </Col>
    //                 </Row>
    //             </Card>
    //             <Card className="p-3 mt-5">
    //                 <h6 className="subTitle">Company Information</h6>
    //                 {/* Contact Person Detail */}
    //                 <Row>
    //                     <Col md={3}>
    //                         <label>Company Name (legal name) <span className="text-danger">*</span></label>
    //                     </Col>
    //                     <Col md={5}>
    //                         <Form.Control type="text" className="form-control" name="companyName" placeholder="Enter here..." {...register("companyName", {
    //                             required: "Company name is required"
    //                         })} />
    //                         {errors.companyName && <p className="text-danger">{errors.companyName.message}</p>}

    //                     </Col>
    //                 </Row>
    //                 {/* Brand Name */}
    //                 <Row>
    //                     <Col md={3}>
    //                         <label>Brand Name</label>
    //                     </Col>
    //                     <Col md={5}>
    //                         <Form.Control type="text" className="form-control" name="brand" placeholder="Enter here..." {...register("brand",
    //                             // {required: "Brand name is required"}
    //                         )} />
    //                         {/* {errors.brand && <p className="text-danger">{errors.brand.message}</p>} */}

    //                     </Col>
    //                 </Row>
    //                 {/* City Name */}
    //                 <Row>
    //                     <Col md={3}>
    //                         <label>City Name</label>
    //                     </Col>
    //                     <Col md={5}>
    //                         <Form.Control type="text" className="form-control" name="city" placeholder="Enter here..." {...register("city",
    //                             // {required: "City name is required"}
    //                         )} />
    //                         {/* {errors.city && <p className="text-danger">{errors.city.message}</p>} */}

    //                     </Col>
    //                 </Row>
    //                 {/* Country Name */}
    //                 <Row>
    //                     <Col md={3}>
    //                         <label>Country Name</label>
    //                     </Col>
    //                     <Col md={5}>
    //                         <Form.Control type="text" className="form-control" name="country" placeholder="Enter here..." {...register("country",
    //                             // {required: "Country name is required"}
    //                         )} />
    //                         {/* {errors.country && <p className="text-danger">{errors.country.message}</p>} */}

    //                     </Col>
    //                 </Row>
    //                 {/* Company Address */}
    //                 <Row>
    //                     <Col md={3}>
    //                         <label>Company Address</label>
    //                     </Col>
    //                     <Col md={5}>
    //                         <Form.Control as="textarea" rows={6} className="form-control" name="address" placeholder="Enter here..." {...register("address",
    //                             // {required: "Company Address is required"}
    //                         )} />
    //                         {/* {errors.address && <p className="text-danger">{errors.address.message}</p>} */}

    //                     </Col>
    //                 </Row>
    //             </Card>
    //             <Button type="submit" variant="primary" className="mt-3 submitBtn" size="lg">Create</Button>
    //             <Button type="button" variant="secondary" className="mx-5 mt-3 cancelBtn" onClick={() => navigate("/dashboard")} style={{}}>Cancel</Button>
    //         </form>
    //     </Card>

    // )
    return (
        <PublisherForm mode="add" />
    )
}

export default AddPublisher;